import { render, staticRenderFns } from "./UbicationAlternative.vue?vue&type=template&id=3ddfc63c"
import script from "./UbicationAlternative.vue?vue&type=script&lang=js"
export * from "./UbicationAlternative.vue?vue&type=script&lang=js"
import style0 from "./UbicationAlternative.vue?vue&type=style&index=0&id=3ddfc63c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports